import gql from "graphql-tag";

export const GET_STATE_BY_CODE = gql`
  query GetStateByCode($code: String!) {
    states(code: $code, countryId: "1") {
      id
    }
  }
`;
